import { render } from "./Policies.vue?vue&type=template&id=455d4a98&scoped=true"
import script from "./Policies.vue?vue&type=script&lang=js"
export * from "./Policies.vue?vue&type=script&lang=js"

import "./Policies.vue?vue&type=style&index=0&id=455d4a98&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-455d4a98"

export default script